import {isBrowser} from "../../Utils"
import EnvironmentUrlProvider from "./Environment"
import {EnvObject} from "./Environment/types"

const configurer = () => {
    let currentConfig: any

    if (!isBrowser) {
        currentConfig = {
            SITE_BASE_URL: '',
            API_BASE_URL: '',
            PORTAL_LOGIN_URL: '',
        }
    } else {
        const envConf: EnvObject = EnvironmentUrlProvider.GetEnvironmentConfig()

        if (envConf && envConf.urls) {
            currentConfig = {
                SITE_BASE_URL: envConf.urls.site,
                API_BASE_URL: envConf.urls.api,
                PORTAL_LOGIN_URL: envConf.urls.login
            }
        }
    }

    return currentConfig
}

export default configurer()